import { render, staticRenderFns } from "./PNHeader.vue?vue&type=template&id=4a904964"
import script from "./PNHeader.vue?vue&type=script&lang=js"
export * from "./PNHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports